// =============================================================
// VARIANCE — The Executive Command Center
// File      : Login.tsx
// Location  : /home/Applications/variance/web/src/pages/Login.tsx
// Owner     : VARIANCE frontend application only
// Purpose   : Premium split-screen login page matching the logo.
// =============================================================

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Lock } from 'lucide-react';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Connect to CogniFleet AUTH
    console.log('Login attempt:', email, password);
  };

  return (
    <div className="flex h-screen w-full" style={{ backgroundColor: '#050505' }}>
      
      {/* LEFT SIDE: Branding (60%) */}
      <div className="hidden lg:flex w-3/5 flex-col items-center justify-center relative overflow-hidden">
        {/* Subtle background glow */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-600 rounded-full mix-blend-screen filter blur-[128px] opacity-20"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gray-500 rounded-full mix-blend-screen filter blur-[128px] opacity-10"></div>

        <div className="relative z-10 flex flex-col items-center max-w-2xl text-center px-8">
          <img 
            src="/assets/images/logo6+-bgr.png" 
            alt="VARIANCE" 
            className="w-full max-w-lg mb-8 drop-shadow-2xl"
          />
          <h2 className="text-2xl font-light tracking-wide text-gray-300 mb-2">
            Focus on What Matters <span className="text-red-600 font-bold">&</span> Act on What Counts.
          </h2>
          <p className="text-sm tracking-widest text-gray-500 uppercase mt-4">
            A Comprehensive View of the Enterprise
          </p>
        </div>
      </div>

      {/* RIGHT SIDE: Login Form (40%) */}
      <div className="w-full lg:w-2/5 flex items-center justify-center p-8">
        <div className="w-full max-w-md p-8 rounded-2xl bg-[#111111] border border-gray-800 shadow-2xl">
          
          <div className="mb-8 text-center lg:text-left">
            <h1 className="text-3xl font-bold text-white mb-2">Welcome Back</h1>
            <p className="text-gray-400 text-sm">Log in to your dashboard.</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-400 mb-1">Email Address</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Mail size={18} className="text-gray-500" />
                </div>
                <input 
                  type="email" 
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full pl-10 pr-3 py-3 bg-[#050505] border border-gray-700 rounded-lg text-white focus:outline-none focus:border-red-600 focus:ring-1 focus:ring-red-600 transition-all"
                  placeholder="ceo@cognifleet.in"
                />
              </div>
            </div>

            <div>
              <div className="flex justify-between items-center mb-1">
                <label className="block text-sm font-medium text-gray-400">Password</label>
                <a href="#" className="text-xs text-red-500 hover:text-red-400">Forgot password?</a>
              </div>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock size={18} className="text-gray-500" />
                </div>
                <input 
                  type="password" 
                  required
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  className="w-full pl-10 pr-3 py-3 bg-[#050505] border border-gray-700 rounded-lg text-white focus:outline-none focus:border-red-600 focus:ring-1 focus:ring-red-600 transition-all"
                  placeholder="••••••••"
                />
              </div>
            </div>

            <button 
              type="submit" 
              className="w-full py-3 px-4 bg-red-700 hover:bg-red-600 text-white font-bold rounded-lg transition-all shadow-[0_0_15px_rgba(220,38,38,0.3)] hover:shadow-[0_0_25px_rgba(220,38,38,0.5)] mt-4"
            >
              Sign In
            </button>
          </form>

          <div className="mt-8 text-center text-sm text-gray-500">
            Don't have an account? <Link to="/signup" className="text-red-500 hover:text-red-400 font-medium">Sign Up</Link>
          </div>

        </div>
      </div>

    </div>
  );
}
